import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, ArrowRight } from 'lucide-react';

const ThankYou = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="min-h-[70vh] bg-white flex items-center">
      <section className="w-full py-24 md:py-32">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">

          <div className="mx-auto w-20 h-20 rounded-full bg-[#f5c518]/15 flex items-center justify-center">
            <CheckCircle2 className="w-10 h-10 text-[#315c4a]" />
          </div>

          <span className="inline-flex mt-8 px-4 py-2 rounded-full border border-slate-200 bg-slate-50 text-[#315c4a] text-[11px] tracking-[0.25em] font-bold uppercase">
            GPE · ÉNERGIES & SERVICES
          </span>

          <h1 className="mt-7 text-[#0b1c3a] font-black leading-[1] tracking-tight text-5xl md:text-6xl lg:text-7xl">
            Merci pour{' '}
            <span className="font-serif italic text-[#f5c518]">
              votre message.
            </span>
          </h1>

          <p className="mt-6 max-w-2xl mx-auto text-lg md:text-xl text-slate-500 leading-relaxed">
            Votre demande a bien été envoyée.
            <br />
            Notre équipe vous contactera prochainement.
          </p>

          <Link
            to="/"
            className="inline-flex items-center gap-2 mt-10 px-7 py-4 rounded-full bg-[#0b3b8c] hover:bg-[#082e6f] text-white font-bold text-sm transition-colors shadow-md shadow-blue-900/20"
          >
            Retour à l’accueil
            <ArrowRight className="w-4 h-4" />
          </Link>

        </div>
      </section>
    </main>
  );
};

export default ThankYou;
